export default __webpack_public_path__ + "static/media/suwa_tablet.5ec3a7c8.png";